import React, { FC, useState } from 'react';
import Subheading from '../font/Subheading';
import styled from 'styled-components';

import { useAppSelector } from '../../redux/redux.hooks';
import Spacer from '../layout/Spacer';
import { IoDesktopSharp } from 'react-icons/io5';
import { GoDeviceMobile } from 'react-icons/go';
import { P } from '../font/Parargraph';
import { AdvancedSettings } from '../../types/fitQuizButton/ButtonState';
import { getContrastedColor } from '../../utils/color.helper';

type FitquizPreviewProps = {};

const FitquizPreview: FC<FitquizPreviewProps> = () => {
  const sizes = ['XS', 'S', 'M', 'L', 'XL'];
  const [desktopHoverStyle, setDesktopHoverStyle] = useState<any>(undefined);
  const [desktopHoverFontStyle, setDesktopHoverFontStyle] = useState<
    { color: string } | undefined
  >(undefined);
  const [desktopHoverIconStyle, setDesktopHoverIconStyle] = useState<
    | {
        background: string;
      }
    | undefined
  >(undefined);
  const [mobileHoverStyle, setMobileHoverStyle] = useState<any>(undefined);
  const [mobileHoverFontStyle, setMobileHoverFontStyle] = useState<
    { color: string } | undefined
  >(undefined);
  const [mobileHoverIconStyle, setMobileHoverIconStyle] = useState<
    | {
        background: string;
      }
    | undefined
  >(undefined);
  const { data } = useAppSelector((state) => state.fitButtonReducer);
  const {
    desktopAndButtonStyleSame,
    fontColor,
    iconType,
    specialIcon,
    hangerIcon,
    shoeIcon,
    apparelIcon,
    bottomsIcon,
    jacketIcon,
    swimwearIcon,
    customIconUrl,

    desktopAdvancedSettings,
    mobileAdvancedSettings,
  } = data;

  const iconScale = 1.64;
  const desktopIconSize = Math.floor(
    desktopAdvancedSettings.fontSize * iconScale
  );
  const mobileIconSize = Math.floor(
    mobileAdvancedSettings.fontSize * iconScale
  );
  const desktopCustomIconSize = desktopIconSize * 0.92;
  const mobileCustomIconSize = mobileIconSize * 0.92;

  const generatePreviewStyle = (isMobile: boolean) => ({
    color: fontColor,
    cursor: 'pointer',
    transition: 'color 1s',
    fontSize: isMobile
      ? mobileAdvancedSettings.fontSize
      : desktopAdvancedSettings.fontSize,
    fontWeight: parseInt(
      isMobile
        ? mobileAdvancedSettings.fontWeight
        : desktopAdvancedSettings.fontWeight
    ),
    textDecoration: isMobile
      ? mobileAdvancedSettings.underline
        ? 'underline'
        : 'none'
      : desktopAdvancedSettings.underline
      ? 'underline'
      : 'none',
    textTransform: isMobile
      ? mobileAdvancedSettings.onlyCapitalLetters
        ? ('uppercase' as any)
        : 'none'
      : desktopAdvancedSettings.onlyCapitalLetters
      ? ('uppercase' as any)
      : 'none',
    textDecorationColor: fontColor,
  });

  const desktopPreviewStyle = generatePreviewStyle(false);
  const mobilePreviewStyle = generatePreviewStyle(true);

  // TODO: Don't return add to state
  const handleMouseEnter = (isMobile: boolean) => {
    let settings: AdvancedSettings = isMobile
      ? mobileAdvancedSettings
      : desktopAdvancedSettings;
    if (settings.hoverStyle === 'None') {
      isMobile
        ? setMobileHoverStyle({
            textDecoration: 'none',
            background: settings.backgroundColor,
          })
        : setDesktopHoverStyle({
            textDecoration: 'none',
            background: settings.backgroundColor,
          });
      isMobile
        ? setMobileHoverFontStyle({ color: fontColor })
        : setDesktopHoverFontStyle({ color: fontColor });
      isMobile
        ? setMobileHoverIconStyle({
            background: fontColor,
          })
        : setDesktopHoverIconStyle({
            background: fontColor,
          });
    } else if (settings.hoverStyle === 'Underline') {
      isMobile
        ? setMobileHoverStyle({
            textDecoration: 'underline',
            background: settings.backgroundColor,
            textDecorationColor: fontColor,
          })
        : setDesktopHoverStyle({
            textDecoration: 'underline',
            background: settings.backgroundColor,
            textDecorationColor: fontColor,
          });
      isMobile
        ? setMobileHoverFontStyle({ color: fontColor })
        : setDesktopHoverFontStyle({ color: fontColor });
      isMobile
        ? setMobileHoverIconStyle({
            background: fontColor,
          })
        : setDesktopHoverIconStyle({
            background: fontColor,
          });
    } else {
      const contrastedColor = getContrastedColor(
        settings.hoverBackgroundColor!
      );

      isMobile
        ? setMobileHoverStyle({
            textDecoration: 'none',
            background: settings.hoverBackgroundColor,
          })
        : setDesktopHoverStyle({
            textDecoration: 'none',
            background: settings.hoverBackgroundColor,
          });
      isMobile
        ? setMobileHoverFontStyle({ color: contrastedColor })
        : setDesktopHoverFontStyle({ color: contrastedColor });
      isMobile
        ? setMobileHoverIconStyle({
            background: contrastedColor,
          })
        : setDesktopHoverIconStyle({
            background: contrastedColor,
          });
    }
  };

  const handleMouseExit = (isMobile: boolean) => {
    let settings: AdvancedSettings = isMobile
      ? mobileAdvancedSettings
      : desktopAdvancedSettings;
    if (isMobile) {
      setMobileHoverStyle({
        textDecoration: 'none',
        background: settings.backgroundColor,
      });
      setMobileHoverFontStyle({ color: fontColor });
      setMobileHoverIconStyle({
        background: fontColor,
      });
    } else {
      setDesktopHoverStyle({
        textDecoration: 'none',
        background: settings.backgroundColor,
      });
      setDesktopHoverFontStyle({ color: fontColor });
      setDesktopHoverIconStyle({
        background: fontColor,
      });
    }
  };

  const iconUrl = () => {
    switch (iconType) {
      case 'Special':
        return specialIcon.url;
      case 'Hanger':
        return hangerIcon.url;
      case 'Shoe':
        return shoeIcon.url;
      case 'Swimwear':
        return swimwearIcon.url;
      case 'Bottom':
        return bottomsIcon.url;
      case 'Jacket':
        return jacketIcon.url;
      case 'Apparel':
        return apparelIcon.url;
      case 'Custom':
        return customIconUrl;
      case 'None':
        return '';
    }
  };

  const generateBorder = (isMobile: boolean) => {
    //TODO: Potential issue
    const advancedSettings = isMobile
      ? mobileAdvancedSettings
      : desktopAdvancedSettings;

    switch (advancedSettings.borderType) {
      case 'none':
        return {
          border: 0,
          margin: `${advancedSettings.margin.top}px ${advancedSettings.margin.horizontal}px ${advancedSettings.margin.bottom}px`,
          padding: `${advancedSettings.padding.vertical}px ${advancedSettings.padding.horizontal}px`,
        };
      case 'bottom':
        return {
          borderBottom: `1px ${advancedSettings.borderShape} ${advancedSettings.borderColor}`,
          padding: `${advancedSettings.padding.vertical}px ${advancedSettings.padding.horizontal}px`,
          margin: `${advancedSettings.margin.top}px ${advancedSettings.margin.horizontal}px ${advancedSettings.margin.bottom}px`,
          borderRadius: `${advancedSettings.borderRadius}px`,
        };
      case 'all':
        return {
          border: `1px ${advancedSettings.borderShape} ${advancedSettings.borderColor}`,
          padding: `${advancedSettings.padding.vertical}px ${advancedSettings.padding.horizontal}px`,
          margin: `${advancedSettings.margin.top}px ${advancedSettings.margin.horizontal}px ${advancedSettings.margin.bottom}px`,
          borderRadius: `${advancedSettings.borderRadius}px`,
        };
    }
  };

  const desktopBorder = generateBorder(false);
  const mobileBorder = generateBorder(true);

  const desktopBackgroundColor = {
    backgroundColor: `${desktopAdvancedSettings.backgroundColor}`,
  };

  const mobileBackgroundColor = {
    backgroundColor: `${mobileAdvancedSettings.backgroundColor}`,
  };

  const desktopStyle = {
    ...desktopBorder,
    ...desktopBackgroundColor,
    ...desktopPreviewStyle,
    display: 'flex',
    alignItems: 'flex-end',
    width: desktopAdvancedSettings.width,
    justifyContent: desktopAdvancedSettings.justifyContent,
  };

  const mobileStyle = {
    ...mobileBorder,
    ...mobileBackgroundColor,
    ...mobilePreviewStyle,
    display: 'flex',
    alignItems: 'flex-end',
    width: mobileAdvancedSettings.width,
    justifyContent: mobileAdvancedSettings.justifyContent,
  };

  const createCustomIconBackground = (isMobile: boolean) => ({
    backgroundImage: `url(${iconUrl()})`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: `${
      isMobile ? mobileCustomIconSize : desktopCustomIconSize
    }px`,
    backgroundPosition: '1px 0px',
  });

  const createRegularIconBackground = (isMobile: boolean) => ({
    WebkitMaskImage: `url(${iconUrl()})`,
    WebkitTextFillColor: `${fontColor}`,
    WebkitTextStrokeColor: `${fontColor}`,
    background: `${fontColor}`,
    WebkitMaskSize: `${isMobile ? mobileIconSize : desktopIconSize}px`,
    WebkitMaskPosition: 'center',
    WebkitMaskRepeat: 'no-repeat',
  });

  const desktopCustomIconBackground = createCustomIconBackground(false);
  const mobileCustomIconBackground = createCustomIconBackground(true);

  const desktopRegularIconBackground = createRegularIconBackground(false);
  const mobileRegularIconBackground = createRegularIconBackground(true);

  const getIconStyle = (isMobile: boolean) =>
    iconType === 'Custom'
      ? isMobile
        ? mobileCustomIconBackground
        : desktopCustomIconBackground
      : isMobile
      ? mobileRegularIconBackground
      : desktopRegularIconBackground;

  const createIconStyle = (isMobile: boolean) => ({
    marginRight: '8px',
    transistion: 'background 0.5s',
    height: `${isMobile ? mobileIconSize : desktopIconSize}px`,
    width: `${isMobile ? mobileIconSize : desktopIconSize}px`,
    background: `${
      !isMobile
        ? desktopAdvancedSettings.hoverStyle === 'Background'
          ? desktopAdvancedSettings.hoverBackgroundColor
          : desktopAdvancedSettings.backgroundColor
        : mobileAdvancedSettings.hoverStyle === 'Background'
        ? mobileAdvancedSettings.hoverBackgroundColor
        : mobileAdvancedSettings.backgroundColor
    }px`,
    ...getIconStyle(isMobile),
  });

  const desktopIconStyle = createIconStyle(false);
  const mobileIconStyle = createIconStyle(true);

  const renderSizeElements = () => (
    <SizeContainer>
      {sizes.map((size, index) => (
        <SizeElements key={`k-${index}`}>
          <Subheading>{size}</Subheading>
        </SizeElements>
      ))}
    </SizeContainer>
  );

  const renderDesktopCtaButton = () => (
    <div
      style={{ ...desktopStyle, ...desktopHoverStyle }}
      onMouseEnter={() => handleMouseEnter(false)}
      onMouseLeave={() => handleMouseExit(false)}
    >
      {iconType !== 'None' && (
        <div style={{ ...desktopIconStyle, ...desktopHoverIconStyle }} />
      )}
      <span style={desktopHoverFontStyle}>Not sure about the size</span>
    </div>
  );

  const renderMobileCtaButton = () => (
    <div
      style={{ ...mobileStyle, ...mobileHoverStyle }}
      onMouseEnter={() => handleMouseEnter(true)}
      onMouseLeave={() => handleMouseExit(true)}
    >
      {iconType !== 'None' && (
        <div style={{ ...mobileIconStyle, ...mobileHoverIconStyle }} />
      )}
      <span style={mobileHoverFontStyle}>Not sure about the size</span>
    </div>
  );

  const renderContainer = (isMobile: boolean) => {
    const renderCTAButton = isMobile
      ? renderMobileCtaButton()
      : renderDesktopCtaButton();
    return (
      <>
        {isMobile ? <GoDeviceMobile size={20} /> : <IoDesktopSharp size={20} />}
        <Container>
          {renderSizeElements()}
          {desktopAndButtonStyleSame
            ? renderDesktopCtaButton()
            : renderCTAButton}
          <AddCartButton>
            <P>Add to cart</P>
          </AddCartButton>
        </Container>
      </>
    );
  };

  return (
    <Wrapper>
      {renderContainer(false)}
      <Spacer width={0} height={36} />
      {renderContainer(true)}
    </Wrapper>
  );
};

export default FitquizPreview;

const Wrapper = styled.div`
  display: 'flex';
  flex-direction: column;
  width: 80%;
`;

const Container = styled.div`
  padding: 0 12px;
  width: 100%;
  min-height: 160px;
  background-color: white;
  overflow-y: hidden;
`;

const SizeContainer = styled.div`
  display: flex;
`;

const SizeElements = styled.div`
  background: #cad5e6;
  opacity: 0.4;
  padding: 8px 12px;
  margin-top: -8px;
  margin-right: 12px;
  border-radius: 4px;
`;

const AddCartButton = styled.div`
  text-align: center;
  background: #cad5e6;
  opacity: 0.4;
  padding: 8px 12px;
  border-radius: 8px;
`;
